module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/money.3d0de975.svg";